import React, { useState, useMemo, useCallback } from "react";
import "../index.css";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router";
import backIcon from "../../../img/Arrow.png";
import locateIcon from "../../../img/location-icon.png";
import tickIcon from "../../../img/icon-tick.png";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../Others/Loading";
import {
  deleteAddress,
  updatePrimary,
} from "../../../Request/UserRequests";
import { saveAddress } from "../../../Redux/Actions/userActions";
const ManageAddress = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userAddress = useSelector((state) => state.user?.address);
  const changePrimaryAddress = (addressId) => {
    updatePrimary(addressId).then((res) => {
      const newCopy = JSON.parse(JSON.stringify(userAddress));

      const oldPrimeIndex = newCopy.findIndex((el) => {
        if (el.primary) {
          return true;
        }
      });
      const newPrimeIndex = newCopy.findIndex((el) => {
        if (el.addressId === addressId) {
          return true;
        }
      });
      newCopy[newPrimeIndex].primary = true;
      newCopy[oldPrimeIndex].primary = null;

      dispatch(saveAddress(newCopy));
    });
  };
  const deleteAddressdipatch = useCallback(
    (addressId) => {
      const newCopy = JSON.parse(JSON.stringify(userAddress));

      const index = newCopy.findIndex((address) => {
        if (address.addressId === addressId) {
          return true;
        }
      });
      if (index !== -1) {
        //check if the address is primary or not
        if (newCopy[index].primary) {
          let i;
          if (index === 0) {
            i = index + 1;
          }
          if (index > 0) {
            i = index - 1;
          }
          updatePrimary(newCopy[i].addressId).then(() => {
            newCopy[i].primary = true;
            newCopy.splice(index, 1);
            dispatch(saveAddress(newCopy));
          });
          return;
        }
        newCopy.splice(index, 1);
      }

      dispatch(saveAddress(newCopy));
    },
    [userAddress]
  );
  return userAddress ? (
    <div className="ma1">
      <div className="ma2 fixed-top d-flex align-items-center transition text-orange bg-white ">
        <div className="text-center my-auto ma3">
          <img src={backIcon} alt="" width={24} onClick={() => navigate(-1)} />
        </div>
        <div className="w-100 my-auto overflow-hidden">
          <h2 className="ma4">Manage Address</h2>
        </div>
      </div>

      <>
        {userAddress
          .slice(0)
          .reverse()
          .map((addressObj) => (
            <AddressCard
              addressObj={addressObj}
              key={addressObj.addressId}
              changePrimaryAddress={changePrimaryAddress}
              navigate={navigate}
              deleteAddressdipatch={deleteAddressdipatch}
            />
          ))}
        <div className="bottom-bar newAddressBar">
          <button
            type="button"
            className="btn w-100 text-orange ma10"
            onClick={() => navigate("/account/manage-address/addnew")}
          >
            <span className="ma11">+ </span> Add new Address
          </button>
        </div>
      </>
    </div>
  ) : (
    <Loading />
  );
};
const AddressCard = ({
  addressObj,
  changePrimaryAddress,
  navigate,
  deleteAddressdipatch,
}) => {
  const {
    address,
    addressId,
    area,
    city,
    lat,
    long,
    name,
    pincode,
    primary,
    state,
  } = addressObj;

  const [showDeleteBox, setShowDeleteBox] = useState(false);
  const deleteAddressFX = useCallback(() => {
    deleteAddress(addressId).then((data) => {
      deleteAddressdipatch(addressId);
    });

    setShowDeleteBox(false);
  }, []);

  return (
    <>
      <div className="bg-white address-card mb-1">
        <div className="d-flex align-items-center justify-content-between sec-title">
          <h2 className="ma5">Delivery Address</h2>
        </div>
        <div className="addCard-item" key={addressId}>
          <div className="d-flex align-items-center addCard-item">
            <div className="addCard-img">
              <img src={locateIcon} alt="locateIcon" width={20} />
            </div>
            <div>
              <h4>
                {area}, {city}
              </h4>
              <h5>{address}</h5>
            </div>
            <div
              onClick={() => {
                if (primary) {
                  return;
                }
                changePrimaryAddress(addressId);
              }}
              className={`ms-auto paytick ${primary ? "active" : ""}`}
            >
              <img src={tickIcon} alt="tickIcon" width={13} />
            </div>
          </div>
          <div
            className="d-flex justify-content-stretch align-items-center"
            style={{ margin: "16px 0 -10px" }}
          >
            <button
              type="button"
              className="btn flex-fill ma7"
              onClick={() => setShowDeleteBox(true)}
            >
              Delete Address
            </button>
            <div className="ma8"></div>
            <button
              type="button"
              className="btn flex-fill ma9"
              onClick={() =>
                navigate(`/account/manage-address/edit/${addressId}`)
              }
            >
              Edit Address
            </button>
          </div>
        </div>
      </div>
      <DeleteAddress
        showDeleteBox={showDeleteBox}
        setShowDeleteBox={setShowDeleteBox}
        deleteAddressFX={deleteAddressFX}
      />
    </>
  );
};

const DeleteAddress = ({
  showDeleteBox,
  setShowDeleteBox,
  deleteAddressFX,
}) => {
  const backdrop = useMemo(
    () => ({
      name: "Eable backdrop",
      scroll: false,
      backdrop: true,
    }),
    []
  );
  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={showDeleteBox}
      className="custom-modal"
      onHide={() => setShowDeleteBox(false)}
    >
      <Modal.Header closeButton={false}>
        <Modal.Title id="contained-modal-title-vcenter">
          Are you sure want to Delete <br />the Address?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-stretch">
          <button
            type="button"
            className="btn flex-fill btn-outline-secondary"
            onClick={() => setShowDeleteBox(false)}
          >
            No, Cancel
          </button>
          <div style={{ width: "16px" }}></div>
          <button
            type="button"
            className="btn flex-fill btn-outline-danger"
            onClick={deleteAddressFX}
          >
            Yes, Delete
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ManageAddress;
